export default __webpack_public_path__ + "static/media/vachan.1ec36f14.jpg";